import React, {
    createContext,
    useContext,
    useEffect,
    useState
} from 'react';
import { CountertopUniversityContextType } from '../types/CountertopUniversityContextType';
import { useGetMultipleSupportEnabled } from '../api/get-is-multiple-support-enabled';

const CountertopUniversityContext = createContext<CountertopUniversityContextType>({} as CountertopUniversityContextType);
const useCountertopUniversity = () => useContext(CountertopUniversityContext);

function CountertopUniversityProvider(props: React.PropsWithChildren<unknown>) {
    const { data: isMultipleProfileSupportEnabled, isLoading } = useGetMultipleSupportEnabled();

    const [countertopUniversityId, setCountertopUniversityId] = useState<number | null>(null);
    const [profileID, setProfileID] = useState<number | null>(null);
    const [profileFullName, setProfileFullName] = useState<string>('');
    const [certUrl, setCertUrl] = useState<string | null>(null);
    const [courseTitle, setCourseTitle] = useState<string | null>(null);

    const [multipleProfileSupport, setMultipleProfileSupport] = useState<boolean>(false);
    const [profilePopupVisible, setProfilePopupVisible] = useState<boolean>(false);
    const [certificationPopupVisible, setCertificationPopupVisible] = useState<boolean>(false);
    const [certificateViewerPopupVisible, setCertificateViewerPopupVisible] = useState<boolean>(false);
    const [onDataRefresh, setOnDataRefresh] = useState<(() => void) | null>(null);

    useEffect(() => {
        if (!isLoading && typeof isMultipleProfileSupportEnabled === 'boolean') {
            setMultipleProfileSupport(isMultipleProfileSupportEnabled);
            setProfilePopupVisible(isMultipleProfileSupportEnabled);
        }
    }, [isLoading, isMultipleProfileSupportEnabled]);

    if (isLoading || typeof isMultipleProfileSupportEnabled !== 'boolean') {
        return null;
    }

    return (
        <CountertopUniversityContext.Provider
            value={{
                countertopUniversityId,
                setCountertopUniversityId,
                profileID,
                setProfileID,
                multipleProfileSupport,
                setMultipleProfileSupport,
                profileFullName,
                setProfileFullName,
                profilePopupVisible,
                setProfilePopupVisible,
                certificationPopupVisible,
                setCertificationPopupVisible,
                certUrl,
                setCertUrl,
                certificateViewerPopupVisible,
                setCertificateViewerPopupVisible,
                courseTitle,
                setCourseTitle,
                onDataRefresh,
                setOnDataRefresh
            }}
            {...props}
        />
    );
}

export { CountertopUniversityProvider, useCountertopUniversity };
